import { render, staticRenderFns } from "./ProductGeneralEditorCard.vue?vue&type=template&id=79b0083c&scoped=true&"
import script from "./ProductGeneralEditorCard.vue?vue&type=script&lang=js&"
export * from "./ProductGeneralEditorCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductGeneralEditorCard.vue?vue&type=style&index=0&id=79b0083c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b0083c",
  null
  
)

export default component.exports